import ClassNames from "classnames";
import { FunctionComponent, ReactNode } from "react";
import styles from "../stylesheets/components/typography-wrapper-inner.module.css";
import { MediaAlign, TextWidth } from "../types/index.js";

interface Props {
  mediaAlign?: MediaAlign;
  width?: TextWidth;
  mediaType?: "image" | "map";
  className?: string;
  children: ReactNode;
}

const TypographyWrapperInner: FunctionComponent<Props> = ({
  mediaAlign,
  width,
  mediaType,
  className,
  children,
}) => {
  return (
    <div
      className={ClassNames(styles.TypographyWrapperInner, className, {
        [styles["TypographyWrapperInner--media-right"]]: mediaAlign === "right",
        [styles["TypographyWrapperInner--narrow"]]: width === "narrow",
        [styles["TypographyWrapperInner--wide"]]: width === "wide",
        [styles["TypographyWrapperInner--with-image"]]: mediaType === "image",
        [styles["TypographyWrapperInner--with-map"]]: mediaType === "map",
      })}
    >
      {children}
    </div>
  );
};

export default TypographyWrapperInner;
